// extracted by mini-css-extract-plugin
export default {"container":"cO-z","topReviewHeading":"dO-z","criticalReview":"eO-z","favorableReview":"fO-z","vsSeparator":"gO-z"};